"use client";

import React from "react";

import LayoutError from "@components/Errors/LayoutError/LayoutError.tsx";

export default function Error() {
  return <LayoutError />;
}
